import { IStatus } from '@dfl/mui-react-common';
import { KEYWORD_COLORS, KEYWORD_PRIORITY_ENUM } from '../interfaces';

export const KEYWORD_PRIORITY_STATUS = (t: any): IStatus[] =>
  Object.keys(KEYWORD_PRIORITY_ENUM).map((p: string) => ({
    _id: p,
    title: t(`keyword:priority.${p}`),
    color: KEYWORD_COLORS[p as KEYWORD_PRIORITY_ENUM],
  }));

export const KEYWORD_PRIORITY_STATUS_MAP = (t: any) =>
  new Map<KEYWORD_PRIORITY_ENUM, IStatus>(
    Object.keys(KEYWORD_PRIORITY_ENUM).map((p: string, index: number) => [
      p as KEYWORD_PRIORITY_ENUM,
      KEYWORD_PRIORITY_STATUS(t)[index],
    ]),
  );
